import './CalculatorPage.scss';
import React from 'react';
import Calculator from '../../contains/calculator/Calculator';

function CalculatorPage({t}) {

  return (
    <div className="calculator-page-wrapper">
     <Calculator t={t}/>
    </div>
  );
}

export default CalculatorPage;